import { useMemo, useState } from "react";
import { useFetch } from "@/lib/useFetch";
import { useAuth } from "@/context/AuthContext";
import PlanGate from "@/app/PlanGate";
import { PageHeader, Spinner, Money, StatusBadge } from "@/app/ui";
import { fmtDate } from "@/lib/format";

function startOfWeek(d) { const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); x.setHours(0, 0, 0, 0); return x; }

function PlannerInner() {
  const { user } = useAuth();
  const sym = user?.business?.currency || "£";
  const { data, loading } = useFetch("/jobs");
  const [anchor, setAnchor] = useState(new Date());

  const week = useMemo(() => {
    const s = startOfWeek(anchor);
    return Array.from({ length: 7 }, (_, i) => { const d = new Date(s); d.setDate(s.getDate() + i); return d; });
  }, [anchor]);

  if (loading || !data) return <Spinner />;
  const jobs = data.items || [];
  const forDay = (d) => jobs.filter((j) => j.scheduled_date && new Date(j.scheduled_date).toDateString() === d.toDateString());

  return (
    <div className="animate-fade-up">
      <PageHeader title="Planner" description="Your week of scheduled work at a glance."
        action={<div className="flex gap-2">
          <button onClick={() => setAnchor(new Date(anchor.setDate(anchor.getDate() - 7)) && new Date(anchor))} className="px-3 py-2 rounded-lg border border-slate-300 text-sm" data-testid="planner-prev">←</button>
          <button onClick={() => setAnchor(new Date())} className="px-3 py-2 rounded-lg border border-slate-300 text-sm">Today</button>
          <button onClick={() => setAnchor(new Date(anchor.setDate(anchor.getDate() + 7)) && new Date(anchor))} className="px-3 py-2 rounded-lg border border-slate-300 text-sm" data-testid="planner-next">→</button>
        </div>} />
      <div className="grid gap-3 md:grid-cols-7">
        {week.map((d) => {
          const isToday = d.toDateString() === new Date().toDateString();
          const dayJobs = forDay(d);
          return (
            <div key={d.toISOString()} className={`amden-card p-3 min-h-[160px] ${isToday ? "ring-2 ring-blue-500" : ""}`} data-testid={`planner-day-${d.getDate()}`}>
              <div className="text-center pb-2 border-b border-slate-100">
                <p className="text-xs text-slate-400">{d.toLocaleDateString("en-GB", { weekday: "short" })}</p>
                <p className={`text-lg font-semibold ${isToday ? "text-blue-accent" : "text-navy"}`}>{d.getDate()}</p>
              </div>
              <div className="space-y-2 mt-2">
                {dayJobs.map((j) => (
                  <div key={j.id} className="rounded-lg bg-blue-50 border border-blue-100 p-2">
                    <p className="text-xs font-medium text-navy truncate">{j.title}</p>
                    <p className="text-[11px] text-slate-500 truncate">{j.customer_name}</p>
                  </div>
                ))}
                {dayJobs.length === 0 && <p className="text-[11px] text-slate-300 text-center pt-4">No jobs</p>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function Planner() { return <PlanGate feature="planner"><PlannerInner /></PlanGate>; }
